// extracted by mini-css-extract-plugin
export var alignCenter = "InlineCTABox-module--align-center--30c45";
export var alignLeft = "InlineCTABox-module--align-left--68762";
export var alignRight = "InlineCTABox-module--align-right--42f09";
export var buttonsContainer = "InlineCTABox-module--buttons-container--b0daf";
export var content = "InlineCTABox-module--content--805e0";
export var inlineCtaBox = "InlineCTABox-module--inline-cta-box--0486a";
export var spacingBottomCompact = "InlineCTABox-module--spacing-bottom-compact--facc7";
export var spacingBottomRegular = "InlineCTABox-module--spacing-bottom-regular--c22d0";
export var spacingTopCompact = "InlineCTABox-module--spacing-top-compact--64404";
export var spacingTopRegular = "InlineCTABox-module--spacing-top-regular--24a0b";